import { InfoIcon } from "../../assets/icons";

interface LoanCalculatorMessageProps {
  message?: string;
  variant?: "warning" | "error" | "info";
  className?: string;
  iconClassName?: string;
}

const messageVariantStyles: Record<string, string> = {
  warning: "cx-border-orange-200 cx-bg-orange-50 cx-text-black",
  error: "cx-border-red-200 cx-bg-red-50 cx-text-black",
  info: "cx-border-brand-primary-regular/30 cx-bg-brand-primary-regular/5 cx-text-text-primary",
};

export const MessageBar: React.FC<LoanCalculatorMessageProps> = ({
  message,
  variant = "warning",
  className = "",
  iconClassName = "",
}) => {
  if (!message) return null;
  return (
    <div
      className={`cx-w-full cx-flex cx-items-center cx-gap-2 cx-rounded-xl cx-border cx-px-4 cx-py-3 cx-text-sm cx-shadow-sm ${messageVariantStyles[variant]} ${className}`}
    >
      <InfoIcon
        className={`cx-w-12 cx-h-12 max-md:cx-mr-1 md:cx-w-4 md:cx-h-4 cx-text-orange-600 ${iconClassName}`}
      />
      <span>{message}</span>
    </div>
  );
};
